import { Flex, Form } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepGuidelines: React.FC<Props> = props => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4} style={{ marginBottom: '32px' }}>
          How would you like me to handle the conversation?
        </TitlePrimary>

        <Flex vertical className="w-full">
          <CommonClient.Form.InputWrapper
            description="Frequently-asked questions and answers can be very useful"
            children={null}
          />
          <Form.Item
            name={['instructions', 'guidelines']}
            rules={[{ required: true }]}
          >
            <TextArea rows={10} maxLength={3000} showCount />
          </Form.Item>
        </Flex>
      </CommonClient.Onboarding.Step>
    </>
  )
}
